module.exports = __webpack_public_path__ + "img/lock.4f492325.svg";